import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchCalendar(payload) {
  return { type: actionTypes.FETCH_ONE, payload };
}
export function fetchCalendarSuccess(payload) {
  // console.log('payload', payload)
  const byId = { [(payload[0].EVENT_ID.toString() + 'h')]: payload[0] };
  return { type: actionTypes.FETCH_ONE_SUCCESS, payload: { byId } };
}
export function fetchCalendars(payload) {
  return { type: actionTypes.FETCH_COLLECTION, payload };
}
export function fetchCalendarsSuccess(paylaod) {
  // console.log('connection....', paylaod)
  // console.log('post...', posts, params)
  const byId = keyBy(paylaod, (con) => (con.EVENT_ID.toString() + 'h'));
  // console.log('byid., byId)
  return { type: actionTypes.FETCH_COLLECTION_SUCCESS, payload: { byId } };
}
export function saveCalendarFavorite(payload) {
  return { type: actionTypes.SAVE_FAVORITE, payload }
}
export function saveCalendarFavoriteSuccess(payload) {
  // console.log('savefavorite...', payload)
  return { type: actionTypes.SAVE_FAVORITE_SUCCESS, payload }
}
export function removeCalendarFavorite(payload) {
  return { type: actionTypes.REMOVE_FAVORITE, payload }
}
export function removeCalendarFavoriteSuccess(payload) {
  return { type: actionTypes.REMOVE_FAVORITE_SUCCESS, payload }
}
export function getCalendarFavorites(payload) {
  return { type: actionTypes.GET_FAVORITES, payload }
}
export function getCalendarFavoritesSuccess(payload) {
  // console.log('favorites....', payload)
  const byId = keyBy(payload, (fav) => (fav.favoriteUid));
  return { type: actionTypes.GET_FAVORITES_SUCCESS, payload: { byId } }
}